module.exports = __webpack_public_path__ + "img/Honigloeffel-v2-150.8af4b196.png";